import BaseComponent from "../../../../baseComponent.js";
import Header from "./hearder.jsx";
import Example from "./example.jsx";
import Parameters from "./parameters.jsx";
import styles from "./styles.scss";

export default class FunctionDetail extends BaseComponent {
  componentWillMount() {
    this.minimized = this.props.minimized;
  }

  toggleContent() {
    this.props.toggleContent();
  }

  render() {
    var style = {};
    if (this.minimized) {
      style = {
        display: "none"
      };
    }
    return (
      <div className="function-detail formula-bar-popup">
        <Header function={this.props.function} argIndex={this.props.argIndex} minimized={this.minimized}
                toggleContent={this.toggleContent}/>
        <div className="function-detail__content" style={style}>
          <Example function={this.props.function} argIndex={this.props.argIndex}/>
          <Parameters function={this.props.function} argIndex={this.props.argIndex}/>
        </div>
      </div>
    );
  }
}

 


// WEBPACK FOOTER //
// ./src/components/analytic-studio/spreadsheet/functions/detail/functionDetail.jsx